import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API service functions
export const apiService = {
  // Contact form submission
  submitContact: async (contactData) => {
    try {
      const response = await api.post('/contact', contactData);
      return response.data;
    } catch (error) {
      console.error('Contact submission error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to submit contact form');
    }
  },

  // Course enrollment
  enrollCourse: async (enrollmentData) => {
    try {
      const response = await api.post('/enroll', enrollmentData);
      return response.data;
    } catch (error) {
      console.error('Enrollment error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to process enrollment');
    }
  },

  // Get course information
  getCourses: async () => {
    try {
      const response = await api.get('/courses');
      return response.data;
    } catch (error) {
      console.error('Get courses error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to fetch courses');
    }
  },

  // Get course statistics
  getStats: async () => {
    try {
      const response = await api.get('/stats');
      return response.data;
    } catch (error) {
      console.error('Get stats error:', error);
      // Return default stats on error
      return {
        students_trained: 500,
        course_modules: 7,
        practical_lessons: 42,
        cost_savings: "70%"
      };
    }
  },

  // Newsletter subscription
  subscribeNewsletter: async (email) => {
    try {
      const response = await api.post('/newsletter', { email });
      return response.data;
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      throw new Error(error.response?.data?.detail || 'Failed to subscribe to newsletter');
    }
  },

  // Health check
  healthCheck: async () => {
    try {
      const response = await api.get('/');
      return response.data;
    } catch (error) {
      console.error('Health check error:', error);
      throw new Error('Backend server is not responding');
    }
  }
};

export default apiService;